import React, { useEffect, useRef, useState } from 'react'
import { Box, Button, Card, CardHeader, Container, Dialog, DialogContent, DialogTitle, Divider, Grid, IconButton, InputLabel, MenuItem, Select, Switch, TextField, Tooltip, Typography, styled } from '@mui/material'
import { Formik } from 'formik'
import * as Yup from "yup";
import CloseIcon from '@mui/icons-material/Close';
import CancelIcon from '@mui/icons-material/Cancel';
import axios from 'axios';
import { toast } from 'react-toastify';


export default function UserDialog({ dialogOpen, setDialogOpen, updateID, setUpdateID }) {

    const [isUpdate, setIsUpdate] = useState(false);
    const [username, setUsername] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const [role, setRole] = useState();
    console.log(updateID);

    // Handle Sign Up form submission
    const handleSignUp = async (e) => {
        e.preventDefault();
        try {
            // Replace with your backend API URL for signing up
            const response = await axios.post('https://serverukautotech.ccsoftwares.com/Users/addUser', {
                username,
                email,
                password,
                role
            });

            // If the signup is successful, set a success message
            setSuccess('Login..');
            setError('');
            // Clear the form fields
            setUsername('');
            setEmail('');
            setPassword('');
            handleClose();

        } catch (err) {
            setSuccess('');
            setError('Error creating account. Please try again.');
        }
    };
    function handleClose() {
        setDialogOpen(false);
    }
    useEffect(() => {
        getUserByID()
    }, [updateID])
    function getUserByID() {
        axios.get(`https://serverukautotech.ccsoftwares.com/Users/getUserByEmail/${updateID}`)
            .then((res) => {
                console.log(res.data);
                // setUsername(res.data[0].Name)
                // setEmail(res.data[0].email)
                // setRole(res.data[0].role)

            })
    }
    return (
        <Dialog
            aria-labelledby="customized-dialog-title"
            open={dialogOpen}
            fullWidth={true}         // Ensures the dialog uses the full width of the container
            maxWidth='md'
        >
            <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
                Add User
            </DialogTitle>
            <IconButton
                aria-label="close"
                onClick={handleClose}
                sx={{
                    position: 'absolute',
                    right: 8,
                    top: 8,
                    color: (theme) => theme.palette.grey[500],
                }}
            >
                <CloseIcon sx={{ color: 'black' }} />
            </IconButton>
            <DialogContent dividers>
                <Container maxWidth={false}>
                    <form onSubmit={handleSignUp}>
                        <Grid container spacing={4}>
                            <Grid item md={12} sx={{ display: 'flex', justifyContent: 'center', paddingTop: '10px' }}>
                            </Grid>
                            <Grid item md={12}>
                                <TextField
                                    id="username"
                                    label="Username"
                                    variant="outlined"
                                    size='large'
                                    fullWidth
                                    value={username}
                                    onChange={(e) => setUsername(e.target.value)}
                                />
                            </Grid>
                            <Grid item md={12}>
                                <TextField
                                    id="email"
                                    label="Email"
                                    variant="outlined"
                                    size='large'
                                    fullWidth
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                />
                            </Grid>
                            <Grid item md={12}>
                                <TextField
                                    id="password"
                                    label="Password"
                                    type="password"
                                    variant="outlined"
                                    size='large'
                                    fullWidth
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                />
                            </Grid>
                            
                            <Grid item md={12}>
                                <InputLabel id="branch-label">Role</InputLabel>
                                {/* <Box sx={{ display: 'flex', justifyContent: 'end' }}> */}
                                <TextField
                                    select
                                    fullWidth
                                    // onBlur={handleBlur}
                                    // name='status'
                                    value={role}
                                    id='status'
                                    onChange={(e) => { setRole(e.target.value) }}
                                    variant="outlined"
                                // size="small"
                                // sx={{ width: { md: '30%', xs: '60%' } }}
                                >
                                    <MenuItem key={0} value={1}>Admin</MenuItem>
                                    <MenuItem key={3} value={2}>Cashier</MenuItem>
                                </TextField>
                                {/* </Box> */}
                            </Grid>
                            {error && (
                                <Grid item md={12}>
                                    <Typography color="error" align="center">{error}</Typography>
                                </Grid>
                            )}
                            {success && (
                                <Grid item md={12}>
                                    <Typography color="primary" align="center">{success}</Typography>
                                </Grid>
                            )}
                            <Grid item md={12} xs={12}>
                                <center>
                                    <Button
                                        variant="contained"
                                        size='large'
                                        sx={{
                                            width: '70%',
                                            fontFamily: 'sans-serif',
                                        }}
                                        type="submit"
                                    >
                                        Add User
                                    </Button>
                                </center>
                            </Grid>
                        </Grid>
                    </form>
                </Container>
            </DialogContent>
        </Dialog >
    )
}
